import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function CreateRoutesPanes() {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    if (!map.getPane('highlightPane')) {
      map.createPane('highlightPane');
      map.getPane('highlightPane')!.style.zIndex = '400';
    }
  }, [map]);

  return null;
}
